/**
 * Device-local calendar date as YYYY-MM-DD. We deliberately do NOT use
 * `new Date().toISOString()` here: that returns the UTC date, so a payment
 * recorded after midnight Cairo time (UTC+2/+3) would be stamped with the
 * PREVIOUS day. Reading the local Y/M/D components gives the correct calendar
 * date the user actually sees, and handles DST automatically.
 */
export function todayLocalISO(offsetDays = 0) {
  const d = new Date();
  d.setDate(d.getDate() + offsetDays);
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  return `${d.getFullYear()}-${mm}-${dd}`;
}
